// 基础配置
const config = {
    baseURL: 'https://www.flowtric.com',
    // baseURL: 'http://10.2.106.181:8081',
}
export function joinUrl(url){
    return config.baseURL + url
}
/**
 * 检查并修复URL编码
 * @param {string} path 路径
 * @returns {string} 编码后的路径
 */
export function encodePath(path) {
    if (!path) return ''

    // 如果已经包含编码字符，先解码再编码（避免双重编码）
    try {
        // 尝试解码，如果已经是编码过的，会成功解码
        const decoded = decodeURIComponent(path)
        // 重新编码，确保所有特殊字符都被正确处理
        return encodeURIComponent(decoded).replace(/%2F/g, '/').replace(/%3A/g, ':')
    } catch (e) {
        // 解码失败，说明可能包含未编码的字符，直接编码
        return encodeURIComponent(path).replace(/%2F/g, '/').replace(/%3A/g, ':')
    }
}

/**
 * 安全地拼接URL路径部分
 * @param {...string} parts URL各部分
 * @returns {string} 拼接后的URL
 */
export function joinPath(...parts) {
    return parts
        .filter(part => part && part.trim())
        .map(part => {
            // 移除多余斜杠，保留一个
            let cleanPart = part.trim()
            // 移除开头和结尾的斜杠（中间处理时会添加）
            cleanPart = cleanPart.replace(/^\/+|\/+$/g, '')
            return cleanPart
        })
        .filter(part => part.length > 0)
        .join('/')
}

/**
 * 构建完整的URL
 * @param {string} base 基础URL
 * @param {string} relativePath 相对路径
 * @returns {string} 完整URL
 */
export function buildFullUrl(base, relativePath) {
    if (!relativePath || relativePath.length === 0) return base

    // 如果已经是完整URL，直接返回
    if (isAbsoluteUrl(relativePath)) {
        return relativePath
    }

    // 处理相对路径中的特殊字符
    let encodedPath = encodePath(relativePath)

    // 确保路径以斜杠分隔
    const cleanBase = base.replace(/\/$/, '') // 移除末尾斜杠
    const cleanPath = encodedPath.replace(/^\//, '') // 移除开头斜杠

    // 拼接URL
    const fullUrl = `${cleanBase}/${cleanPath}`
    // console.log('最终URL', fullUrl)
    return fullUrl
}

/**
 * 判断是否为绝对URL
 */
export function isAbsoluteUrl(url) {
    return /^(https?:|blob:|data:|ftp:|\/\/)/.test(url)
}

/**
 * 获取资源完整URL（修复空格问题）
 * @param {string} relativePath 相对路径
 * @param {string} type 资源类型
 * @returns {string} 完整URL
 */
export function getFullUrl(relativePath) {

    if (!relativePath || relativePath.length === 0) {
        return false
        // console.log('空路径')
        // return require('@/assets/images/news/news-1.png')
    }

    // 如果已经是完整URL，直接返回
    if (isAbsoluteUrl(relativePath)) {
        // console.log('完整URL')

        try {
            // 对已有的URL进行规范化处理
            const url = new URL(relativePath)
            return url.toString()
        } catch (e) {
            // 如果URL解析失败，尝试编码处理
            return encodeSpacesInUrl(relativePath)
        }
    }

    // 构建完整URL
    return buildFullUrl(config.baseURL, relativePath)
}

/**
 * 专门处理URL中的空格
 */
export function encodeSpacesInUrl(url) {
    // 使用正则匹配并替换空格（但不破坏已有结构）
    return url.replace(/([^:])\/\/+/g, '$1/') // 移除多余的斜杠
        .replace(/(https?:\/\/[^/]+)/, (match) => {
            // 协议和域名部分不编码
            return match
        })
        .replace(/(https?:\/\/[^?#]+)(.*)/, (match, path, rest) => {
            // 只对路径部分进行编码
            const encodedPath = path.split('/').map(segment => {
                // 对每个路径段进行编码，但保留斜杠
                return encodeURIComponent(decodeURIComponent(segment))
            }).join('/')

            // 查询参数和哈希部分单独处理
            return encodedPath + encodeQueryAndHash(rest)
        })
}

/**
 * 编码查询参数和哈希部分
 */
export function encodeQueryAndHash(rest) {
    if (!rest) return ''

    // 分离查询参数和哈希
    const [queryAndHash] = rest.split(/(?=[?#])/)

    if (!queryAndHash) return ''

    // 分别处理查询参数和哈希
    if (queryAndHash.includes('?')) {
        const [query, hash] = queryAndHash.split('#')
        const encodedQuery = query ? '?' + encodeURI(query.substring(1)) : ''
        const encodedHash = hash ? '#' + encodeURIComponent(hash) : ''
        return encodedQuery + encodedHash
    }

    // 只有哈希
    if (queryAndHash.startsWith('#')) {
        return '#' + encodeURIComponent(queryAndHash.substring(1))
    }

    return encodeURIComponent(queryAndHash)
}

/**
 * 专门处理视频URL（提供兼容性）
 */
export function getVideoUrl(relativePath) {
    const url = getFullUrl(relativePath, 'video')

    // 额外的视频URL验证和修复
    return fixVideoUrl(url)
}

/**
 * 修复视频URL常见问题
 */
export function fixVideoUrl(url) {
    if (!url) return ''

    let fixedUrl = url

    // 修复常见的视频URL问题
    const fixes = [
        // 修复多个连续的斜杠
        {pattern: /([^:])\/\/+/g, replacement: '$1/'},
        // 确保文件扩展名正确
        {pattern: /\.mp4\s+\.mp4$/, replacement: '.mp4'},
        // 修复空格在扩展名中的问题
        {pattern: /\.(mp4|webm|avi|mov)\s+/, replacement: '.$1'},
        // 修复URL中的非法字符
        {
            pattern: /[\s<>"{}|\\^`]/g, replacement: (match) => {
                return encodeURIComponent(match)
            }
        }
    ]

    fixes.forEach(fix => {
        fixedUrl = fixedUrl.replace(fix.pattern, fix.replacement)
    })

    return fixedUrl
}

/**
 * 测试URL是否有效
 */
export function testUrl(url) {
    try {
        const response = fetch(url, {method: 'HEAD'})
        return response.ok
    } catch (error) {
        console.warn('URL测试失败:', url, error)
        return false
    }
}
